import { set, omit } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import {
  createFetchManyHandler,
  createDeleteHandler
} from '../../../../helpers/reducerRoutineCrudHandler';
import {
  paginationState,
  resetPaginationState
} from '../../../../helpers/pagination';
import { fetchROItems, deleteROItem } from '../../sagas/routines';
import {
  ROItemOnClear,
  ROItemOnChangePage,
  ROItemOnChangeOrder,
  ROItemRemoveItem
} from '../../actions/ro-item';

const initialState = {
  all: {},
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  fetchingError: null,
  deleting: false,
  deleted: false,
  deletingError: null,
  pagination: paginationState(),
  order: 'id:asc'
};

const ROItemOnClearHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    all: {},
    pagination: resetPaginationState(state.pagination)
  })
});

const ROItemOnChangePageHandler = action => ({
  [action.toString()]: (state, { payload: page }) =>
    set('pagination.currentPage', page, state)
});

const ROItemOnChangeOrderHandler = action => ({
  [action.toString()]: (state, { payload: order }) => set('order', order, state)
});

const ROItemRemoveItemHandler = action => ({
  [action.toString()]: (state, { payload: id }) => ({
    ...state,
    all: omit(id, state.all)
  })
});

export default createReducer(initialState, {
  ...createFetchManyHandler(fetchROItems),
  ...createDeleteHandler(deleteROItem),
  ...ROItemOnClearHandler(ROItemOnClear),
  ...ROItemOnChangePageHandler(ROItemOnChangePage),
  ...ROItemOnChangeOrderHandler(ROItemOnChangeOrder),
  ...ROItemRemoveItemHandler(ROItemRemoveItem)
});
